import { getUserByEmail } from '../common/api/userApi';
import { loginMailAndPassword, signOut as signOutApi } from '../common/api/userApi';

export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SET_USER_DATA = 'SET_USER_DATA';
export const RESET_USER_DATA = 'RESET_USER_DATA'
export const SET_USER_SIGNING = 'SET_USER_SIGNING'

const setUserLoading = payload => (
    { type: SET_USER_LOADING, payload }
)

const setUserSigning = payload => (
    { type: SET_USER_SIGNING, payload }
)

const setUserData = payload => (
    { type: SET_USER_DATA, payload }
)

const resetUserData = payload => (
    { type: RESET_USER_DATA, payload }
)

export const login = ({ mail, password, resolve, reject }) => {
    return dispatch => {
        dispatch(setUserLoading({ loading: true }));
        dispatch(setUserSigning())
        loginMailAndPassword(mail, password)
            .then(userInfo => {
                getUserByEmail(userInfo.email).then(user => {
                    const data = user.data()
                    const role = data.role
                    const displayName = data.displayName || ''
                    const permissions = data.permissions || null
                    dispatch(setUserData({ data: userInfo, role, displayName, permissions }))
                    resolve(getRouteByRole(role, permissions))
                    dispatch(setUserLoading({ loading: false }));
                })
            })
            .catch(error => {
                dispatch(setUserLoading({ loading: false }));
                reject(error);
            });
    }
}

const getRouteByRole = (role, permissions) => {
    if (role === 'control-time') return '/control-time'
    if (role === 'admin' || role === 'super') return '/'
    if (permissions) return '/'
    return '/public-stock'
}

export const signOut = ({ callback }) => {
    return dispatch => {
        signOutApi().then(() => {
            dispatch(resetUserData())
            callback && callback()
        })
    }
}

export const relogin = ({ userData }) => {
    return dispatch => {
        dispatch(setUserLoading({ loading: true }));

        getUserByEmail(userData.email).then(user => {
            const data = user.data()
            dispatch(setUserData({
                data: user,
                role: data.role,
                displayName: data.displayName || '',
                permissions: data.permissions || null,
            }));
            dispatch(setUserLoading({ loading: false }));
        })
    }
}

export const setLoadingUserAuth = ({ flag }) => {
    return dispatch => {
        dispatch(setUserLoading({ loading: flag }))
    }
}
